module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_c('em', [_vm._v("Also by the same author")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1"
  }), _vm._v(" "), _c('p', {
    staticClass: "paracenter"
  }, [_vm._v("The Royal Navy and the Northwest Coast"), _c('br'), _vm._v("To the Pacific and Arctic with Beechey"), _c('br'), _vm._v("The Northwest Coast: British Navigation, Trade and Discoveries"), _c('br'), _vm._v("Gunboat Frontier"), _c('br'), _vm._v("HMCS HAIDA: Battle Ensign Flying"), _c('br'), _vm._v("Fighting Sail on Lake Huron and Georgian Bay"), _c('br'), _vm._v("Fortune’s a River: Collision of Empires in Northwest America")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88280d52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Dedication.vue
// module id = 69
// module chunks = 0